import React from 'react';
import {
  LoggedOutProductLibraryContainsItem,
  LoggedOutProductLibraryItem,
  SelectedLibraryItem,
} from '../../../types/library';
import Image from 'next/image';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { Flex } from '@osmosis/tailwind-ui/components/Box';
import { H3 } from '@osmosis/tailwind-ui/components/Text';
import LibrarySidebarAccordion from '../LibrarySidebarAccordian';
import { assets } from '@osmosis/constants';
import { useIntl } from 'react-intl';
import { translateGroupName } from '../../../lib/library/format';

type NavStructureProps = {
  navData: LoggedOutProductLibraryItem[];
  onSelect: (
    l1: LoggedOutProductLibraryContainsItem,
    l2: LoggedOutProductLibraryContainsItem,
  ) => void;
  handleViewedLibraries: (libraryLink: string) => void;
  viewedLibraries: string[];
  selectedItem?: SelectedLibraryItem;
  openIndex?: number;
};

/**
 * Sidebar to display in the logged out library.
 */
const NavStructure = ({
  navData,
  onSelect,
  handleViewedLibraries,
  viewedLibraries,
  selectedItem,
  openIndex,
}: NavStructureProps) => {
  const intl = useIntl();
  return (
    <>
      {navData.map((groupItem, index: number) => {
        if ('groupName' in groupItem) {
          return (
            <React.Fragment key={index}>
              {groupItem.groupName ? (
                <Box cn="ml-2">
                  <Flex cn="items-center">
                    <Image
                      src={assets.logoIcon}
                      alt="Icon"
                      width={20}
                      height={20}
                    />

                    <H3 cn="p-2 ml-1">
                      {translateGroupName(groupItem.groupName, intl)}
                    </H3>
                  </Flex>
                </Box>
              ) : null}
              <Box cn="ml-8">
                {groupItem.navs.map((l1, navItemIndex) => (
                  <LibrarySidebarAccordion
                    l1={l1}
                    index={navItemIndex}
                    onSelect={(l2) => onSelect(l1, l2)}
                    handleViewedLibraries={handleViewedLibraries}
                    viewedLibraries={viewedLibraries}
                    key={l1.name}
                    selectedItem={selectedItem}
                    openIndex={openIndex}
                  />
                ))}
              </Box>
            </React.Fragment>
          );
        } else {
          const l1 = groupItem;
          return (
            <React.Fragment key={index}>
              <LibrarySidebarAccordion
                l1={l1}
                index={index}
                onSelect={(l2) => onSelect(l1, l2)}
                handleViewedLibraries={handleViewedLibraries}
                viewedLibraries={viewedLibraries}
                key={l1.name}
                selectedItem={selectedItem}
                openIndex={openIndex}
              />
            </React.Fragment>
          );
        }
      })}
    </>
  );
};

export default NavStructure;
